var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.loadProductPromotion ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showProductPromotion,
      expression: "showProductPromotion"
    }],
    staticClass: "Layer-FullScreen component-product-promotion",
    on: {
      "click": function click($event) {
        return _vm.slideDownProductPromotion();
      }
    }
  }, [_c('div', {
    staticClass: "main-bottom",
    class: {
      'slide-down': _vm.productPromotionSlideDown
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "btn-close",
    on: {
      "click": function click($event) {
        return _vm.slideDownProductPromotion();
      }
    }
  }), _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("分享海报")]), _c('div', {
    staticClass: "icon-img",
    class: {
      'less-one': (!_vm.password || _vm.type == 1 && !_vm.posterLink || _vm.type == 2 && !_vm.poster || !_vm.shareLink) && !(_vm.isOpenShop && _vm.shareLink),
      'is-point': _vm.isPoint
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_vm.isMini ? _c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.handleShareForwardWechat();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/wechat_friend_icon_v20191210.png"
    }
  }), _c('p', [_vm._v("微信好友")])], 1)]) : _vm._e(), !_vm.shareReward && !_vm.isMini && _vm.password ? _c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.handleCreateAppPoster();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/open_app_promotion_icon_v20191210.png"
    }
  }), _c('p', [_vm._v("生成APP海报")])], 1)]) : _vm._e(), _vm.type == 1 && _vm.posterLink || _vm.type == 2 && _vm.poster ? _c('div', {
    staticClass: "btn-item generate-poster"
  }, [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.handleCreatePoster(_vm._this);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/generate_poster_icon_v20191210.png"
    }
  }), _c('p', [_vm._v("生成海报")])], 1), _vm.isPoint ? _c('div', {
    staticClass: "point-cover"
  }, [_c('div', {
    staticClass: "point-box",
    class: {
      'is-open-shop': _vm.isOpenShop && _vm.shareLink
    }
  }, [_c('span', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.isPoint = false;
      }
    }
  }, [_vm._v("好的")]), _vm._m(0), _c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/point_down_arrow.png"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm.shareLink ? _c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.handleCreateShareLink();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/generate_link_icon_v20191210.png"
    }
  }), _c('p', [_vm._v("短链接")])], 1)]) : _vm._e(), _vm.showVideo ? _c('div', {
    staticClass: "btn-item mt0"
  }, [_c('div', {
    staticClass: "btn-img",
    on: {
      "click": function click($event) {
        return _vm.handleShareVideo();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/share_video.png"
    }
  }), _c('p', [_vm._v("视频号")])], 1)]) : _vm._e()]), _vm.isOpenShop && _vm.shareLink ? _c('div', {
    staticClass: "block branch-block"
  }, [_c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img no-brand",
    on: {
      "click": function click($event) {
        return _vm.handleCreateNoPoster(_vm._this);
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_img_icon.png"
    }
  }), _c('p', [_vm._v("无品牌海报")])], 1)]), _c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img no-brand",
    on: {
      "click": _vm.showQRcode
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_QRcode_icon.png"
    }
  }), _c('p', [_vm._v("无品牌二维码")])], 1)]), _c('div', {
    staticClass: "btn-item"
  }, [_c('div', {
    staticClass: "btn-img no-brand",
    on: {
      "click": _vm.copyNoBrandLink
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/no_brand_link_icon.png"
    }
  }), _c('p', [_vm._v("无品牌链接")])], 1)])]) : _vm._e()])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPasswordCopy,
      expression: "showPasswordCopy"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox password-copy",
    class: {
      'show-animation': _vm.showPasswordCopy,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox(1);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/password_icon.png"
    }
  }), _c('i', {
    on: {
      "click": function click($event) {
        return _vm.hideBox(1);
      }
    }
  }), _c('div', {
    staticClass: "transition-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.passwordCopyStatus == 1,
      expression: "passwordCopyStatus == 1"
    }],
    staticClass: "status-one"
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v("商品口令生成中..")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.passwordCopyStatus == 2 || _vm.passwordCopyStatus == 3,
      expression: "passwordCopyStatus == 2 || passwordCopyStatus == 3"
    }],
    staticClass: "status-two"
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("请在APP中生成海报")]), _c('div', {
    staticClass: "btn-goPage",
    on: {
      "click": _vm.goDownloadPage
    }
  }, [_vm._v("前往APP打开")])])])], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showShareLink,
      expression: "showShareLink"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox share-link",
    class: {
      'show-animation': _vm.showShareLink,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox(2);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/share_link_icon_v20191210.png"
    }
  }), _c('i', {
    on: {
      "click": function click($event) {
        return _vm.hideBox(2);
      }
    }
  }), _c('div', {
    staticClass: "transition-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shareLinkBoxStatus == 1,
      expression: "shareLinkBoxStatus == 1"
    }],
    staticClass: "status-one"
  }, [_c('p', {
    staticClass: "txt-p"
  }, [_vm._v("分享链接生成中..")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shareLinkBoxStatus == 2 || _vm.shareLinkBoxStatus == 3 || _vm.shareLinkBoxStatus == 4,
      expression: "\n            shareLinkBoxStatus == 2 ||\n            shareLinkBoxStatus == 3 ||\n            shareLinkBoxStatus == 4\n          "
    }],
    staticClass: "status-two",
    class: {
      'status-three': _vm.shareLinkBoxStatus == 3 || _vm.shareLinkBoxStatus == 4,
      'status-four': _vm.shareLinkBoxStatus == 4
    }
  }, [_c('p', {
    staticClass: "txt-h"
  }, [_vm._v("\n            " + _vm._s(_vm.shareLinkBoxStatus == 2 ? "长按复制文案" : "分享链接") + "\n          ")]), _c('div', {
    staticClass: "txt-p"
  }, [_c('p', {
    staticClass: "txt-name"
  }, [_vm._v(_vm._s(_vm.shareTxt))]), _c('p', {
    staticClass: "txt-link"
  }, [_vm._v(_vm._s(_vm.shortUrl))])]), _c('div', {
    staticClass: "btn-copy",
    on: {
      "click": function click($event) {
        _vm.copyShortUrl(), _vm.reportUserAnchors(_vm.type == 1 ? '520000' : '520001');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.shareLinkBoxStatus == 3 ? "复制文案" : "再次复制") + "\n          ")])])])], 1)]), _vm.isMini ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showForwardWechat,
      expression: "showForwardWechat"
    }],
    staticClass: "Layer-FullScreen forward-wechat",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.showForwardWechat = false;
      }
    }
  }, [_c('ycf-image', {
    attrs: {
      "src": "/srcv2/images/forward_wechat_guide.png"
    }
  })], 1) : _vm._e(), _vm.isOpenShop && _vm.shareLink ? _c('component-nobrand-qrcode', {
    attrs: {
      "type": _vm.type
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', [_vm._v("点击生成海报，分享朋友圈"), _c('br'), _vm._v("朋友购买即可获得现金奖励")]);
}];
export { render, staticRenderFns };